import ko from "knockout";
import metaCache from "flow/utils/metaCache";
import register from "flow/knockout/register";

register.registerKnockoutBinding("missingText", {
    init() {
        return {
            controlsDescendantBindings: true // Prevent knockout trying to bind to text
        };
    },
    update(element, valueAccessor) {
        handleText(element, valueAccessor);
    }
});

function handleText(element: HTMLElement, valueAccessor: () => any) {
    const key = "FlowHtml.Translations.Missing";
    let missingText = metaCache.lookup(key, key);

    // First get the latest data that we're bound to
    const value = valueAccessor();

    // Next, whether or not the supplied model property is observable, get its current value
    let valueUnwrapped = ko.utils.unwrapObservable(value);

    // You can use the binding like missingText: {property: entityProperty, text: '@Html.Translate("MissingText")'}
    if (value != undefined && value.property != undefined && value.text != undefined) {
        valueUnwrapped = ko.utils.unwrapObservable(value.property);
        missingText = value.text;
    }

    // Empty value or not?
    if (valueUnwrapped == undefined || valueUnwrapped.trim() === "") {
        element.classList.add("lc-missing-text");
        const em = document.createElement("em");
        em.innerText = missingText;
        element.replaceChildren(em);
    } else {
        element.classList.remove("lc-missing-text");
        const text = document.createTextNode(valueUnwrapped);
        element.replaceChildren(text);
    }
}

ko.punches.textFilter.enableForBinding("missingText");
